import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { Helmet } from 'react-helmet';
import Main from "../../components/Layout/Main";
import Section from '../../components/Layout/Section/Section';
import InnerContainer from '../../components/Layout/InnerContainer/InnerContainer';
import CoverImage from "../../components/CoverImage";
import StatisticBlocks from '../../components/StatisticBlocks';
import ThreeStar from '../../components/Dividers/ThreeStar';
import Star from '../../components/Dividers/star';
import EditorialPortrait from '../../components/EditorialPortrait';
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';
import InsightBlocks from '../../components/InsightBlocks';
import Wave from '../Dividers/wave';
import MAIN_SHOW_BREAK_6_EXTRA_PERFORMANCE_Video from '../../../static/video/MAIN_SHOW_BREAK_6_EXTRA_PERFORMANCE.mp4';
import BK_MAINSHOW_PROMO_BREAK_4_Video from '../../../static/video/BK_MAINSHOW_PROMO_BREAK_4.mp4';
import arPerformanceVideo from '../../../static/video/ar_performance.mp4';
import TOYOTA_ACT_3_CUSTOM_SPOT_ALONE_Video from '../../../static/video/TOYOTA_ACT_3_CUSTOM_SPOT_ALONE.mp4';

import './partnerships.scss';

const Partnerships = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query PartnershipsQuery {
      markdownRemark(frontmatter: { pageId: { eq: "partnerships-page" } }) {
        frontmatter {
          components {
            type
            headline
            body {
              line
            }
            logo {
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
            attr
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
              extension
              publicURL
            }
            blocks {
              headline
              headline2
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
              body
              bullets {
                bullet
              }
            }
            caption
            images {
              image {
                childImageSharp {
                  fluid(maxWidth: 2048, quality: 80) {
                    ...GatsbyImageSharpFluid
                  }
                }
                extension
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  function getComponent(name) {
    const components = markdownRemark.frontmatter.components;
    return components.filter(component => component.type === name)[0];
  }

  const CoverImageContent = getComponent("partnershipsCoverImage");
  const PullQuoteLargeContent = getComponent("pullQuoteLarge");
  const StatisticsContent = getComponent("statisticBlocks");
  const CoverImageWavyContent = getComponent("coverImageWavy");
  const TextBlock1Content = getComponent("textBlock1");
  const TextBlock2Content = getComponent("textBlock2");
  const InsightBlocksContent = getComponent("insightBlocks");
  const TextBlock3Content = getComponent("textBlock3");
  const CoverImageWavy2Content = getComponent("coverImageWavy2");
  const TextBlock4Content = getComponent("textBlock4");
  const TextBlock5Content = getComponent("textBlock5");
  const TwosmallImages = getComponent("2smallImages");
  const EditorialPortraitContent = getComponent("editorialPortrait");
  const TextBlock5pt1Content = getComponent("textBlock5pt1");
  const CoverImageWavy3Content = getComponent("coverImageWavy3");
  const TextBlock6Content = getComponent("textBlock6");
  const TextBlock7Content = getComponent("textBlock7");
  const TextBlock7pt1Content = getComponent("textBlock7pt1");
  const TextBlock8Content = getComponent("textBlock8");
  const TextBlock9Content = getComponent("textBlock9");

  return (
    <Main>
      <Helmet>
        <body className="partnerships" />
      </Helmet>
      <CoverImage
        image={CoverImageContent.image}
        headline={CoverImageContent.headline}
        hero="hero"
      />
      <Section customClass={["color-block", "bg-yellow"]}>
        <InnerContainer customClass="pull-quote">
          <Star customClass="star--top"/>
          <h3 className="pull-quote__body large">{PullQuoteLargeContent.body[0].line}</h3>
          <p className="pull-quote__body">{PullQuoteLargeContent.body[1].line}</p>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer customClass="statistic-blocks">
          <StatisticBlocks blocks={StatisticsContent.blocks}/>
        </InnerContainer>
      </Section>
      <CoverImage
        image={CoverImageWavyContent.image}
        headline={CoverImageWavyContent.headline}
        variant="wavy"
        id="toyotaHero"
      />
      <Section customClass={["color-block", "bg-yellow"]}>
        <InnerContainer customClass="pull-quote">
          <Star customClass="star--top"/>
          <h3 className="pull-quote__body large">{TextBlock1Content.body[0].line}</h3>
          <p className="pull-quote__body">{TextBlock1Content.body[1].line}</p>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock1Content.body[2].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <Wave position="wave--relative"/>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock2Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer customClass="insight-blocks">
            <InsightBlocks blocks={InsightBlocksContent.blocks}/>
        </InnerContainer>
      </Section>
      <CoverImage
        id="toyotaAct3"
        video={TOYOTA_ACT_3_CUSTOM_SPOT_ALONE_Video}
        variant="singleFrame"
      />
      <Section>
        <ThreeStar/>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock3Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <ThreeStar/>
      </Section>
      <CoverImage
        image={CoverImageWavy2Content.image}
        headline={CoverImageWavy2Content.headline}
        variant="wavy"
        id="burgerkingHero"
      />
      <Section customClass={["color-block", "bg-yellow"]}>
        <InnerContainer customClass="pull-quote">
          <Star customClass="star--top"/>
          <h3 className="pull-quote__body large">{TextBlock4Content.body[0].line}</h3>
          <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock4Content.body[1].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <Wave position="wave--relative"/>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock5Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <CoverImage
        video={BK_MAINSHOW_PROMO_BREAK_4_Video}
        variant="singleFrame"
      />
      <Section customClass="small-boxes">
        <InnerContainer customClass={["small-boxes__container", "twoUp"]}>
        <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={TwosmallImages.images[0].image} alt="image" />
        <PreviewCompatibleImage customClassName="small-boxes__container__image" imageInfo={TwosmallImages.images[1].image} alt="image" />
        </InnerContainer>
        <p className="small-boxes__caption">{TwosmallImages.caption}</p>
      </Section>
      <EditorialPortrait
        video= {arPerformanceVideo}
        blocks={EditorialPortraitContent.blocks}
      />
      <Section>
        <ThreeStar/>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock5pt1Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <ThreeStar/>
      </Section>
      <CoverImage
        image={CoverImageWavy3Content.image}
        headline={CoverImageWavy3Content.headline}
        variant="wavy"
        id="extraHero"
      />
      <Section customClass={["color-block", "bg-yellow"]}>
        <InnerContainer customClass="pull-quote">
        <Star customClass="star--top"/>
        <h3 className="pull-quote__body large">{TextBlock6Content.body[0].line}</h3>
        <Star customClass="star--bottom"/>
        </InnerContainer>
      </Section>
      <Section>
        <Wave position="wave--relative"/>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock7Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <CoverImage
        video={MAIN_SHOW_BREAK_6_EXTRA_PERFORMANCE_Video}
        variant="singleFrame"
      />
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock7pt1Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer>
          <Star customClass="star--top"/>
        </InnerContainer>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock8Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <ThreeStar/>
      </Section>
      <Section>
        <InnerContainer customClass="text-block">
          <p className="text-block__body small">{TextBlock9Content.body[0].line}</p>
        </InnerContainer>
      </Section>
      <Section>
        <ThreeStar/>
      </Section>
    </Main>
  )
}

export default Partnerships;
